import PauseIcon from '@components/icons/Pause.svg';
import PlayIcon from '@components/icons/Play.svg';
import { TProps } from './types/TProps';
// import { LoadingIcon } from "@components/icons/Loading"';

export const Controls = ({ isPlaying, setIsPlaying, disabled }: TProps) => {
  return (
    <div className="controls flex items-center justify-center gap-2.5">
      {/* {isLoading ? (*/}
      {/*  <button*/}
      {/*    className="loading"*/}
      {/*    disabled={false}*/}
      {/*    onClick={(e) => {*/}
      {/*      e.preventDefault();*/}
      {/*      setIsPlaying(!isPlaying);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <LoadingIcon />*/}
      {/*  </button>*/}
      {/* ) : (*/}
      <button
        className="play text-[var(--color-text-muted)] hover:text-[var(--color-title)]"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          setIsPlaying(!isPlaying);
        }}
      >
        {isPlaying ? <PauseIcon /> : <PlayIcon />}
      </button>
      {/* )}*/}
    </div>
  );
};
